module.exports = __webpack_public_path__ + "static/media/lawn-garden-equipment.0db0ef31.jpg";